'use client'
import {ProductCategory} from "@/modules/classes/products/ProductCategories";
import {JSX} from "react";
import {Disclosure, Tab} from "@headlessui/react";
import {Fragment} from "react";
import {MinusSmallIcon, PlusSmallIcon} from "@heroicons/react/24/outline";
import {StarIcon} from "@heroicons/react/24/solid";

export default function ProductTabPanels(productCategory: ProductCategory): JSX.Element  {

    return (
        <div className="mx-auto mt-16 w-full max-w-2xl lg:col-span-4 lg:mt-0 lg:max-w-none">
            <Tab.Group as="div">
                <div className="border-b border-gray-200">
                    <Tab.List className="-mb-px flex space-x-8">
                        <Tab as={Fragment}>
                            {({ selected }) => (
                                /* Use the `selected` state to conditionally style the selected tab. */
                                <button
                                    className={
                                        getTabClassNames(selected)
                                    }
                                >
                                    Common Questions (FAQs)
                                </button>
                            )}
                        </Tab>
                        <Tab as={Fragment}>
                            {({ selected }) => (
                                /* Use the `selected` state to conditionally style the selected tab. */
                                <button
                                    className={
                                        getTabClassNames(selected)
                                    }
                                >
                                    Customer Reviews
                                </button>
                            )}
                        </Tab>
                    </Tab.List>
                </div>
                <Tab.Panels as={Fragment}>

                    <Tab.Panel className="text-sm text-gray-500">
                        <h3 className="sr-only">Frequently Asked Questions</h3>

                        <dl>
                            {productCategory.questions.map((faq) => (
                                <Disclosure as="div" key={faq.question} className="pt-6">
                                    {({ open }) => (
                                        <>
                                            <dt>
                                                <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                                                    <span className="text-base font-semibold leading-7">{faq.question}</span>
                                                    <span className="ml-6 flex h-7 items-center">
                                                                             {open ? (
                                                                                 <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                                                                             ) : (
                                                                                 <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                                                                             )}
                                                                        </span>
                                                </Disclosure.Button>
                                            </dt>
                                            <Disclosure.Panel as="dd" className="mt-2 pr-12">
                                                <p className="text-base leading-7 text-gray-600">{faq.answer}</p>
                                            </Disclosure.Panel>
                                        </>
                                    )}
                                </Disclosure>
                            ))}
                        </dl>
                    </Tab.Panel>

                    <Tab.Panel className="-mb-10">
                        <h3 className="sr-only">Customer Reviews</h3>

                        {(productCategory.reviewEntries.reviews.map((review, reviewIdx) => (
                            <div key={review.ID} className="flex space-x-4 text-sm text-gray-500">
                                <div className="flex-none py-10">
                                    <img src={review.authorImageURL} alt="" className="h-10 w-10 rounded-full bg-gray-100" />
                                </div>
                                <div className={getReviewBoxClassName(reviewIdx)}>
                                    <h3 className="font-medium text-gray-900">{review.author}</h3>
                                    <p>
                                        <time dateTime={review.dateCreated.toString()}>{review.dateCreated.getDate()}</time>
                                    </p>

                                    <div className="mt-4 flex items-center">
                                        {[1, 2, 3, 4, 5].map((rating) => (
                                            <StarIcon
                                                key={rating}
                                                className={getStarClassName(rating, review.starRating)}
                                                aria-hidden="true"
                                                fill={getStarFillColor(rating, review.starRating)}
                                            />
                                        ))}
                                    </div>
                                    <p className="sr-only">{review.starRating} out of 5 stars</p>
                                    <div
                                        className="prose prose-sm mt-4 max-w-none text-gray-500"
                                        dangerouslySetInnerHTML={{ __html: review.title }}
                                    />
                                    <div
                                        className="prose prose-sm mt-4 max-w-none text-gray-500"
                                        dangerouslySetInnerHTML={{ __html: review.content }}
                                    />
                                </div>
                            </div>
                        )))}
                    </Tab.Panel>

                </Tab.Panels>
            </Tab.Group>
        </div>
    )

}

function getTabClassNames(selected: boolean) : string {
    if (selected ) {
        return ("border-indigo-600 text-indigo-600 whitespace-nowrap border-b-2 py-6 text-sm font-medium")
    } else {
        return ("border-transparent text-gray-700 hover:text-gray-800 hover:border-gray-300 whitespace-nowrap border-b-2 py-6 text-sm font-medium")
    }
}

function getStarClassName(starNumber: number, avgRating: number): string {

    if (starNumber > avgRating) {
        return ("'text-yellow-400 h-5 w-5 flex-shrink-0 '")
    } else {
        return ("'text-gray-300 h-5 w-5 flex-shrink-0'")
    }

}
function getStarFillColor(starNumber: number, avgRating: number): string {

    if (starNumber <= avgRating) {
        return ("#E3A008")
    } else {
        return ("#D1D5DB")
    }
}

function getReviewBoxClassName(reviewIndex: number): string {

    if (reviewIndex == 0) {
        return ("border-t border-gray-200 py-10")
    } else {
        return ("py-10")
    }

}